import React, { useState } from 'react';
import { Backdrop, Checkbox, FormControlLabel, TextField } from '@material-ui/core';
import { Content, StyledModal, ButtonContainer, StyledButton, Title, FieldsContainer } from './styles';

export interface CostsFormData {
  htCount: string;
  hpCount: string;
  dailyBaseCount: string;
  equipmentCount: string;
  nightWeekendExit: boolean;
  cancellationExitFee: boolean;
}

interface EditCostsModalProps {
  visible: boolean;
  initialData?: Partial<CostsFormData>;
  onClose: () => void;
  onSubmit: (data: CostsFormData) => void;
}

const defaultForm: CostsFormData = {
  htCount: '',
  hpCount: '',
  dailyBaseCount: '',
  equipmentCount: '',
  nightWeekendExit: false,
  cancellationExitFee: false,
};

export const EditCostsModal: React.FC<EditCostsModalProps> = ({ visible, initialData, onClose, onSubmit }) => {
  const [form, setForm] = useState<CostsFormData>({ ...defaultForm, ...initialData });

  const handleOpen = () => {
    setForm({ ...defaultForm, ...initialData });
  };

  const handleClose = () => {
    setForm({ ...defaultForm, ...initialData });
    onClose();
  };

  const handleSubmit = () => {
    onSubmit(form);
  };

  const setField = (field: keyof CostsFormData) => (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm(prev => ({ ...prev, [field]: e.target.value }));
  };

  const setCheck = (field: keyof CostsFormData) => (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm(prev => ({ ...prev, [field]: e.target.checked }));
  };

  return (
    <StyledModal
      aria-labelledby='edit-costs-modal-title'
      open={visible}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
      onRendered={handleOpen}
    >
      <Content>
        <Title id='edit-costs-modal-title'>Editar Custos</Title>
        <FieldsContainer>
          <TextField
            label='HT — hora trabalhada (contagem)'
            type='number'
            value={form.htCount}
            onChange={setField('htCount')}
            inputProps={{ min: 0 }}
            fullWidth
          />
          <TextField
            label='HP — hora parada (contagem)'
            type='number'
            value={form.hpCount}
            onChange={setField('hpCount')}
            inputProps={{ min: 0 }}
            fullWidth
          />
          <TextField
            label='Diária na base (contagem)'
            type='number'
            value={form.dailyBaseCount}
            onChange={setField('dailyBaseCount')}
            inputProps={{ min: 0 }}
            fullWidth
          />
          <TextField
            label='Equipamento (contagem)'
            type='number'
            value={form.equipmentCount}
            onChange={setField('equipmentCount')}
            inputProps={{ min: 0 }}
            fullWidth
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={form.nightWeekendExit}
                onChange={setCheck('nightWeekendExit')}
                color='primary'
              />
            }
            label='Saída noite / Sáb-Dom'
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={form.cancellationExitFee}
                onChange={setCheck('cancellationExitFee')}
                color='primary'
              />
            }
            label='Taxa cancelamento saída'
          />
        </FieldsContainer>
        <ButtonContainer>
          <StyledButton type='text' filled label='Cancelar' onClick={handleClose} />
          <StyledButton type='text' filled label='Salvar' onClick={handleSubmit} />
        </ButtonContainer>
      </Content>
    </StyledModal>
  );
};
